/**
 * Colour theme (dark | light) for the web app. A single `data-theme`
 * attribute on <html>; glasswork.css / obsidian.css re-resolve their
 * variables off it and glasswork.js re-reads them on change. Persisted per
 * browser. Default: dark.
 */
const KEY = 'quantum.theme';

export function getTheme() {
  try { return localStorage.getItem(KEY) === 'light' ? 'light' : 'dark'; }
  catch { return 'dark'; }
}

export function applyTheme(t) {
  try { localStorage.setItem(KEY, t); } catch { /* private mode */ }
  document.documentElement.setAttribute('data-theme', t);
}

export function toggleTheme() {
  const next = getTheme() === 'dark' ? 'light' : 'dark';
  applyTheme(next);
  return next;
}

/** Call once at boot, before React renders, to avoid a flash of the wrong theme. */
export function initTheme() {
  document.documentElement.setAttribute('data-theme', getTheme());
}
